import { useEffect, useState } from "react";
import { Poll, PollOption } from "../postCard/PostCard";
import cx from "./pollCard.module.scss";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { createVote } from "src/store/socialMedia/socialMedia.slice";
import { ConfirmModal, Typography } from "src/components/common";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

export default function PollCard({ pollData, viewerId, handlePoll, viewerType }: { pollData: Poll, viewerId: string, handlePoll: any, viewerType: string }) {
    const dispatch = useAppDispatch()
    const isAuthorized: boolean = useAppSelector((store) => store.auth.isAuthorized);
    const navigate = useNavigate()

    const [votesOptions, setVotesOptions] = useState([]);
    const [totalVotes, setTotalVotes] = useState<number>(0)

    const [showResults, setShowResults] = useState(false);
    const [show, setShow] = useState<boolean>(false)

    const url = `${location.pathname}${location.search}`
    const isVoted = votesOptions?.some((option) => option.hasVoted)
    const handleVote = (option: PollOption) => {
        if (!isAuthorized) {
            setShow(true)
            return
        }
        const payload = {
            userId: viewerId,
            optionId: option.id,
            pollId: pollData.id
        }
        dispatch(createVote(payload)).then((res) => {
            if (res.status) {
                handlePoll && handlePoll();
                setShowResults(true)
            }
        })
    };
    function handleNavigate() {
        navigate(`/login?prev=${url}`)
    }

    useEffect(() => {
        if (pollData) {
            setVotesOptions(pollData.options || [])
            setTotalVotes(pollData?.totalVotes || 0)
        }
    }, [pollData])

    return (
        <>
            <div className={cx.pollCard}>
                {/* Question */}
                <Typography
                    as="p"
                    variant="body-3"
                    fontWeight="semiBold"
                    className="post-card__announcement-title"
                >
                    {pollData.question}
                </Typography>
                {/* <p className={cx.question}>{pollData.question}</p> */}

                {/* Poll Options */}
                <div className={cx.options}>
                    {votesOptions.map((option, i) => {
                        const percentage = option.percentage;
                        return (
                            <button
                                key={option.id}
                                className={`${cx.optionButton} ${showResults ? cx.showResults : ''}`}
                                onClick={() => !isVoted && handleVote(option)}
                                style={{ backgroundSize: showResults ? `${option.percentage}% 100%` : '0% 100%' }}
                                data-percentage={`${option.percentage}%`}
                            >
                                <p>
                                    {option.text} {option?.hasVoted && <span className={cx.successSymbol}><AiOutlineCheckCircle className={`${cx.checkIcon}`} /></span>}
                                </p>
                                {showResults && <span>{percentage.toFixed(0)}%</span>}
                            </button>
                        );
                    })}
                </div>

                {/* Footer Section */}
                <div className={cx.footer}>
                    <p className={cx.voteCount}>{totalVotes} votes</p>
                    <span className={cx.showResultButton} onClick={() => setShowResults((prev) => !prev)}>{showResults ? "Hide" : "View"} Results</span>
                </div>
            </div>
            <ConfirmModal
                title=""
                description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
                    <span>To enjoy all the features of <span style={{ color: '#fa4616' }}>htraction</span> </span>
                    <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
                </p>}
                openConfirmModal={show}
                onClose={() => setShow(false)}
                onSubmit={handleNavigate}
                submitText="Sign in"
                type="confirm"
            />
        </>
    );
}
